import React from 'react';

const ListSpinner = ({ className = '' }) => (
  <div className={`p-8 text-center ${className}`}>
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600 mx-auto" />
  </div>
);

export default ListSpinner;
